import React from 'react';
import Table from '../../components/ui/Table.jsx';
import Badge from '../../components/ui/Badge.jsx';
import { useApi } from '../../hooks/useApi.js';
import { Link } from '../../router.jsx';

export default function StaffRequests() {
  const [query, setQuery] = React.useState('');
  const [state, setState] = React.useState('all');
  const [offset, setOffset] = React.useState(0);
  const limit = 25;
  const path = `/api/requests?limit=${limit}&offset=${offset}&q=${encodeURIComponent(query)}&state=${encodeURIComponent(state)}`;
  const { data, loading, error } = useApi(path, [query, state, offset]);
  const items = data?.items || [];
  const columns = [
    { key: 'id', label: 'Request' },
    { key: 'student', label: 'Student' },
    { key: 'change', label: 'Change' },
    { key: 'status', label: 'Status' }
  ];

  const tableData = items.map((req) => ({
    id: <Link to={`/staff/requests/${req.id}`}>REQ-{req.id}</Link>,
    student: req.student || req.cin,
    change: `${req.remove_course || '—'} → ${req.add_course || '—'}`,
    status: renderStatus(req)
  }));

  const filters = (
    <>
      <input
        className="input table-search"
        type="search"
        placeholder="Search by student, CIN, or course"
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
          setOffset(0);
        }}
      />
      <select
        className="input table-filter-select"
        aria-label="Filter requests by status"
        value={state}
        onChange={(event) => {
          setState(event.target.value);
          setOffset(0);
        }}
      >
        <option value="all">All statuses</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
      </select>
    </>
  );

  const pagination = {
    offset,
    limit,
    hasNext: items.length === limit,
    onPageChange: setOffset
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Requests</h1>
          <p className="subtle">Review and route course change decisions.</p>
        </div>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      <Table
        columns={columns}
        data={tableData}
        filters={filters}
        pagination={pagination}
        emptyMessage={loading ? 'Loading...' : 'No requests found.'}
      />
    </div>
  );
}

function renderStatus(req) {
  if (req.status === 1 && req.advisor_decision === 0 && req.chair_decision === 0) {
    return <Badge tone="warning">Pending</Badge>;
  }
  if (req.status === 1 && req.advisor_decision === 1 && req.chair_decision === 0) {
    return <Badge tone="info">Chair Review</Badge>;
  }
  if (req.status === 0 && req.chair_decision === 1) {
    return <Badge tone="success">Approved</Badge>;
  }
  if (req.status === 0 && req.chair_decision === 0) {
    return <Badge tone="error">Declined</Badge>;
  }
  return <Badge tone="info">Closed</Badge>;
}
